import { createAction } from '@reduxjs/toolkit';

const pageLoaded = createAction<string, 'page/LOADED'>('page/LOADED');

export { pageLoaded };
